import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IStudentSearchResult } from '../Models/IStudentSearchResult';

@Injectable()
export class StudentSearchService extends  BaseService {

  constructor(protected _http: HttpClient) { super(_http); }

  get(url: string): Observable<IStudentSearchResult[]> {
    return this._http.get<IStudentSearchResult[]>(url).map((response: IStudentSearchResult[]) => response as IStudentSearchResult[])
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    //window.alert('Please enter at least 2 search characters in both Last Name and First Name.');
    return Observable.throw(error);
  }

}
